[
  {
    "type": "fruit-tree",
    "id": "629",
    "name": "Apricot Tree",
    "saplingId": "629",
    "saplingName": "Apricot Sapling",
    "saplingBuyPrices": [
      {
        "place": "Pierre's",
        "price": 2000
      },
      {
        "place": "JojaMart",
        "price": 2500
      }
    ],
    "saplingSellPrice": 500,
    "seasons": ["spring"],
    "daysToMature": 28,
    "description": "A sweet, fleshy fruit with a delicate flavor. One of the first fruits of spring.",
    "image": "images/trees/apricot/harvest.png",
    "saplingImage": "images/trees/apricot/seed.png",
    "stages": [
      {
        "name": "stage 1",
        "image": "images/trees/apricot/stage-1.png"
      },
      {
        "name": "stage 2",
        "image": "images/trees/apricot/stage-2.png"
      },
      {
        "name": "stage 3",
        "image": "images/trees/apricot/stage-3.png"
      },
      {
        "name": "stage 4",
        "image": "images/trees/apricot/stage-4.png"
      },
      {
        "name": "mature",
        "image": "images/trees/apricot/stage-5.png"
      }
    ],
    "produce": {
      "id": "634",
      "name": "Apricot",
      "sellPrice": 50,
      "profession": ["tiller"],
      "image": "images/trees/apricot/crop.png",
      "energyHealth": {
        "energy": 38,
        "health": 17
      },
      "artisanUses": {
        "honey": false,
        "wine": true,
        "juice": false,
        "pickles": false,
        "jelly": true,
        "driedMushrooms": false,
        "driedFruit": true
      }
    },
    "choppedProduce": [
      {
        "id": "629",
        "name": "Apricot Sapling"
      }
    ]
  },
  {
    "type": "fruit-tree",
    "id": "628",
    "name": "Cherry Tree",
    "saplingId": "628",
    "saplingName": "Cherry Sapling",
    "saplingBuyPrices": [
      {
        "place": "Pierre's",
        "price": 3400
      },
      {
        "place": "JojaMart",
        "price": 4250
      }
    ],
    "saplingSellPrice": 850,
    "seasons": ["spring"],
    "daysToMature": 28,
    "description": "This sweet, bright red fruit makes a wonderful preserve.",
    "image": "images/trees/cherry/harvest.png",
    "saplingImage": "images/trees/cherry/seed.png",
    "stages": [
      {
        "name": "stage 1",
        "image": "images/trees/cherry/stage-1.png"
      },
      {
        "name": "stage 2",
        "image": "images/trees/cherry/stage-2.png"
      },
      {
        "name": "stage 3",
        "image": "images/trees/cherry/stage-3.png"
      },
      {
        "name": "stage 4",
        "image": "images/trees/cherry/stage-4.png"
      },
      {
        "name": "mature",
        "image": "images/trees/cherry/stage-5.png"
      }
    ],
    "produce": {
      "id": "638",
      "name": "Cherry",
      "sellPrice": 80,
      "profession": ["tiller"],
      "image": "images/trees/cherry/crop.png",
      "energyHealth": {
        "energy": 38,
        "health": 17
      },
      "artisanUses": {
        "honey": false,
        "wine": true,
        "juice": false,
        "pickles": false,
        "jelly": true,
        "driedMushrooms": false,
        "driedFruit": true
      }
    },
    "choppedProduce": [
      {
        "id": "628",
        "name": "Cherry Sapling"
      }
    ]
  },
  {
    "type": "fruit-tree",
    "id": "630",
    "name": "Orange Tree",
    "saplingId": "630",
    "saplingName": "Orange Sapling",
    "saplingBuyPrices": [
      {
        "place": "Pierre's",
        "price": 4000
      },
      {
        "place": "JojaMart",
        "price": 5000
      }
    ],
    "saplingSellPrice": 1000,
    "seasons": ["summer"],
    "daysToMature": 28,
    "description": "A fragrant, tangy citrus fruit.",
    "image": "images/trees/orange/harvest.png",
    "saplingImage": "images/trees/orange/seed.png",
    "stages": [
      {
        "name": "stage 1",
        "image": "images/trees/orange/stage-1.png"
      },
      {
        "name": "stage 2",
        "image": "images/trees/orange/stage-2.png"
      },
      {
        "name": "stage 3",
        "image": "images/trees/orange/stage-3.png"
      },
      {
        "name": "stage 4",
        "image": "images/trees/orange/stage-4.png"
      },
      {
        "name": "mature",
        "image": "images/trees/orange/stage-5.png"
      }
    ],
    "produce": {
      "id": "635",
      "name": "Orange",
      "sellPrice": 100,
      "profession": ["tiller"],
      "image": "images/trees/orange/crop.png",
      "energyHealth": {
        "energy": 38,
        "health": 17
      },
      "artisanUses": {
        "honey": false,
        "wine": true,
        "juice": false,
        "pickles": false,
        "jelly": true,
        "driedMushrooms": false,
        "driedFruit": true
      }
    },
    "choppedProduce": [
      {
        "id": "630",
        "name": "Orange Sapling"
      }
    ]
  },
  {
    "type": "fruit-tree",
    "id": "631",
    "name": "Peach Tree",
    "saplingId": "631",
    "saplingName": "Peach Sapling",
    "saplingBuyPrices": [
      {
        "place": "Pierre's",
        "price": 6000
      },
      {
        "place": "JojaMart",
        "price": 7500
      }
    ],
    "saplingSellPrice": 1500,
    "seasons": ["summer"],
    "daysToMature": 28,
    "description": "A fuzzy fruit of exceptional sweetness.",
    "image": "images/trees/peach/harvest.png",
    "saplingImage": "images/trees/peach/seed.png",
    "stages": [
      {
        "name": "stage 1",
        "image": "images/trees/peach/stage-1.png"
      },
      {
        "name": "stage 2",
        "image": "images/trees/peach/stage-2.png"
      },
      {
        "name": "stage 3",
        "image": "images/trees/peach/stage-3.png"
      },
      {
        "name": "stage 4",
        "image": "images/trees/peach/stage-4.png"
      },
      {
        "name": "mature",
        "image": "images/trees/peach/stage-5.png"
      }
    ],
    "produce": {
      "id": "636",
      "name": "Peach",
      "sellPrice": 140,
      "profession": ["tiller"],
      "image": "images/trees/peach/crop.png",
      "energyHealth": {
        "energy": 38,
        "health": 17
      },
      "artisanUses": {
        "honey": false,
        "wine": true,
        "juice": false,
        "pickles": false,
        "jelly": true,
        "driedMushrooms": false,
        "driedFruit": true
      }
    },
    "choppedProduce": [
      {
        "id": "631",
        "name": "Peach Sapling"
      }
    ]
  },
  {
    "type": "fruit-tree",
    "id": "69",
    "name": "Banana Tree",
    "saplingId": "69",
    "saplingName": "Banana Sapling",
    "saplingBuyPrices": [],
    "saplingSellPrice": 850,
    "seasons": ["summer"],
    "daysToMature": 28,
    "description": "This delicious tropical fruit smells wonderful, too.",
    "image": "images/trees/banana/harvest.png",
    "saplingImage": "images/trees/banana/seed.png",
    "stages": [
      {
        "name": "stage 1",
        "image": "images/trees/banana/stage-1.png"
      },
      {
        "name": "stage 2",
        "image": "images/trees/banana/stage-2.png"
      },
      {
        "name": "stage 3",
        "image": "images/trees/banana/stage-3.png"
      },
      {
        "name": "stage 4",
        "image": "images/trees/banana/stage-4.png"
      },
      {
        "name": "mature",
        "image": "images/trees/banana/stage-5.png"
      }
    ],
    "produce": {
      "id": "91",
      "name": "Banana",
      "sellPrice": 150,
      "profession": ["tiller"],
      "image": "images/trees/banana/crop.png",
      "energyHealth": {
        "energy": 75,
        "health": 33
      },
      "artisanUses": {
        "honey": false,
        "wine": true,
        "juice": false,
        "pickles": false,
        "jelly": true,
        "driedMushrooms": false,
        "driedFruit": true
      }
    },
    "choppedProduce": [
      {
        "id": "69",
        "name": "Banana Sapling"
      }
    ]
  },
  {
    "type": "fruit-tree",
    "id": "835",
    "name": "Mango Tree",
    "saplingId": "835",
    "saplingName": "Mango Sapling",
    "saplingBuyPrices": [],
    "saplingSellPrice": 850,
    "seasons": ["summer"],
    "daysToMature": 28,
    "description": "A sweet and tangy tropical fruit.",
    "image": "images/trees/mango/harvest.png",
    "saplingImage": "images/trees/mango/seed.png",
    "stages": [
      {
        "name": "stage 1",
        "image": "images/trees/mango/stage-1.png"
      },
      {
        "name": "stage 2",
        "image": "images/trees/mango/stage-2.png"
      },
      {
        "name": "stage 3",
        "image": "images/trees/mango/stage-3.png"
      },
      {
        "name": "stage 4",
        "image": "images/trees/mango/stage-4.png"
      },
      {
        "name": "mature",
        "image": "images/trees/mango/stage-5.png"
      }
    ],
    "produce": {
      "id": "834",
      "name": "Mango",
      "sellPrice": 130,
      "profession": ["tiller"],
      "image": "images/trees/mango/crop.png",
      "energyHealth": {
        "energy": 100,
        "health": 45
      },
      "artisanUses": {
        "honey": false,
        "wine": true,
        "juice": false,
        "pickles": false,
        "jelly": true,
        "driedMushrooms": false,
        "driedFruit": true
      }
    },
    "choppedProduce": [
      {
        "id": "835",
        "name": "Mango Sapling"
      }
    ]
  },
  {
    "type": "fruit-tree",
    "id": "633",
    "name": "Apple Tree",
    "saplingId": "633",
    "saplingName": "Apple Sapling",
    "saplingBuyPrices": [
      {
        "place": "Pierre's",
        "price": 4000
      },
      {
        "place": "JojaMart",
        "price": 5000
      }
    ],
    "saplingSellPrice": 1000,
    "seasons": ["fall"],
    "daysToMature": 28,
    "description": "A crisp fruit that pairs nicely with autumn flavors.",
    "image": "images/trees/apple/harvest.png",
    "saplingImage": "images/trees/apple/seed.png",
    "stages": [
      {
        "name": "stage 1",
        "image": "images/trees/apple/stage-1.png"
      },
      {
        "name": "stage 2",
        "image": "images/trees/apple/stage-2.png"
      },
      {
        "name": "stage 3",
        "image": "images/trees/apple/stage-3.png"
      },
      {
        "name": "stage 4",
        "image": "images/trees/apple/stage-4.png"
      },
      {
        "name": "mature",
        "image": "images/trees/apple/stage-5.png"
      }
    ],
    "produce": {
      "id": "613",
      "name": "Apple",
      "sellPrice": 100,
      "profession": ["tiller"],
      "image": "images/trees/apple/crop.png",
      "energyHealth": {
        "energy": 38,
        "health": 17
      },
      "artisanUses": {
        "honey": false,
        "wine": true,
        "juice": false,
        "pickles": false,
        "jelly": true,
        "driedMushrooms": false,
        "driedFruit": true
      }
    },
    "choppedProduce": [
      {
        "id": "633",
        "name": "Apple Sapling"
      }
    ]
  },
  {
    "type": "fruit-tree",
    "id": "632",
    "name": "Pomegranate Tree",
    "saplingId": "632",
    "saplingName": "Pomegranate Sapling",
    "saplingBuyPrices": [
      {
        "place": "Pierre's",
        "price": 6000
      },
      {
        "place": "JojaMart",
        "price": 7500
      }
    ],
    "saplingSellPrice": 1500,
    "seasons": ["fall"],
    "daysToMature": 28,
    "description": "This fruit has ancient roots. It's bursting with seeds.",
    "image": "images/trees/pomegranate/harvest.png",
    "saplingImage": "images/trees/pomegranate/seed.png",
    "stages": [
      {
        "name": "stage 1",
        "image": "images/trees/pomegranate/stage-1.png"
      },
      {
        "name": "stage 2",
        "image": "images/trees/pomegranate/stage-2.png"
      },
      {
        "name": "stage 3",
        "image": "images/trees/pomegranate/stage-3.png"
      },
      {
        "name": "stage 4",
        "image": "images/trees/pomegranate/stage-4.png"
      },
      {
        "name": "mature",
        "image": "images/trees/pomegranate/stage-5.png"
      }
    ],
    "produce": {
      "id": "637",
      "name": "Pomegranate",
      "sellPrice": 140,
      "profession": ["tiller"],
      "image": "images/trees/pomegranate/crop.png",
      "energyHealth": {
        "energy": 38,
        "health": 17
      },
      "artisanUses": {
        "honey": false,
        "wine": true,
        "juice": false,
        "pickles": false,
        "jelly": true,
        "driedMushrooms": false,
        "driedFruit": true
      }
    },
    "choppedProduce": [
      {
        "id": "632",
        "name": "Pomegranate Sapling"
      }
    ]
  },
  {
    "type": "wild-tree",
    "id": "1",
    "name": "Oak Tree",
    "seedId": "309",
    "seedName": "Acorn",
    "description": "A sturdy deciduous tree common throughout the valley. Can be tapped for Oak Resin.",
    "image": "images/trees/oak/portrait.png",
    "seedImage": "images/trees/oak/seed.png",
    "stages": [
      {
        "name": "stage 1",
        "image": "images/trees/oak/stage-1.png"
      },
      {
        "name": "stage 2",
        "image": "images/trees/oak/stage-2.png"
      },
      {
        "name": "stage 3",
        "image": "images/trees/oak/stage-3.png"
      },
      {
        "name": "stage 4",
        "image": "images/trees/oak/stage-4.png"
      },
      {
        "name": "mature",
        "image": "images/trees/oak/stage-5.png"
      }
    ],
    "tapper": {
      "id": "725",
      "name": "Oak Resin",
      "sellPrice": 150,
      "profession": ["tapper"],
      "image": "images/forageables/Oak Resin.png"
    },
    "choppedProduce": [
      {
        "id": "388",
        "name": "Wood"
      },
      {
        "id": "92",
        "name": "Sap"
      },
      {
        "id": "309",
        "name": "Acorn"
      }
    ]
  },
  {
    "type": "wild-tree",
    "id": "2",
    "name": "Maple Tree",
    "seedId": "310",
    "seedName": "Maple Seed",
    "description": "A beautiful tree with vibrant fall colors. Produces a sweet, valuable syrup.",
    "image": "images/trees/maple/portrait.png",
    "seedImage": "images/trees/maple/seed.png",
    "stages": [
      {
        "name": "stage 1",
        "image": "images/trees/maple/stage-1.png"
      },
      {
        "name": "stage 2",
        "image": "images/trees/maple/stage-2.png"
      },
      {
        "name": "stage 3",
        "image": "images/trees/maple/stage-3.png"
      },
      {
        "name": "stage 4",
        "image": "images/trees/maple/stage-4.png"
      },
      {
        "name": "mature",
        "image": "images/trees/maple/stage-5.png"
      }
    ],
    "tapper": {
      "id": "724",
      "name": "Maple Syrup",
      "sellPrice": 200,
      "profession": ["tapper"],
      "image": "images/forageables/Maple Syrup.png",
      "energyHealth": {
        "energy": 50,
        "health": 22
      }
    },
    "choppedProduce": [
      {
        "id": "388",
        "name": "Wood"
      },
      {
        "id": "92",
        "name": "Sap"
      },
      {
        "id": "310",
        "name": "Maple Seed"
      }
    ]
  },
  {
    "type": "wild-tree",
    "id": "3",
    "name": "Pine Tree",
    "seedId": "311",
    "seedName": "Pine Cone",
    "description": "A resilient evergreen that stays green throughout the year.",
    "image": "images/trees/pine/portrait.png",
    "seedImage": "images/trees/pine/seed.png",
    "stages": [
      {
        "name": "stage 1",
        "image": "images/trees/pine/stage-1.png"
      },
      {
        "name": "stage 2",
        "image": "images/trees/pine/stage-2.png"
      },
      {
        "name": "stage 3",
        "image": "images/trees/pine/stage-3.png"
      },
      {
        "name": "stage 4",
        "image": "images/trees/pine/stage-4.png"
      },
      {
        "name": "mature",
        "image": "images/trees/pine/stage-5.png"
      }
    ],
    "tapper": {
      "id": "726",
      "name": "Pine Tar",
      "sellPrice": 100,
      "profession": ["tapper"],
      "image": "images/forageables/Pine Tar.png"
    },
    "choppedProduce": [
      {
        "id": "388",
        "name": "Wood"
      },
      {
        "id": "92",
        "name": "Sap"
      },
      {
        "id": "311",
        "name": "Pine Cone"
      }
    ]
  },
  {
    "type": "wild-tree",
    "id": "8",
    "name": "Mahogany Tree",
    "seedId": "292",
    "seedName": "Mahogany Seed",
    "description": "A rare hardwood tree. When tapped, it produces sap every day.",
    "image": "images/trees/mahogany/portrait.png",
    "seedImage": "images/trees/mahogany/seed.png",
    "stages": [
      {
        "name": "stage 1",
        "image": "images/trees/mahogany/stage-1.png"
      },
      {
        "name": "stage 2",
        "image": "images/trees/mahogany/stage-2.png"
      },
      {
        "name": "stage 3",
        "image": "images/trees/mahogany/stage-3.png"
      },
      {
        "name": "stage 4",
        "image": "images/trees/mahogany/stage-4.png"
      },
      {
        "name": "mature",
        "image": "images/trees/mahogany/stage-5.png"
      }
    ],
    "tapper": {
      "id": "92",
      "name": "Sap",
      "sellPrice": 2,
      "profession": [],
      "image": "images/forageables/Sap.png",
      "energyHealth": {
        "energy": -2,
        "health": -1
      }
    },
    "choppedProduce": [
      {
        "id": "292",
        "name": "Mahogany Seed"
      },
      {
        "id": "709",
        "name": "Hardwood"
      }
    ]
  },
  {
    "type": "wild-tree",
    "id": "7",
    "name": "Mushroom Tree",
    "seedId": "891",
    "seedName": "Mushroom Tree Seed",
    "description": "A peculiar tree covered in fungi. Produces mushrooms when tapped.",
    "image": "images/trees/mushroom/portrait.png",
    "seedImage": "images/trees/mushroom/seed.png",
    "stages": [
      {
        "name": "stage 1",
        "image": "images/trees/mushroom/stage-1.png"
      },
      {
        "name": "stage 2",
        "image": "images/trees/mushroom/stage-2.png"
      },
      {
        "name": "stage 3",
        "image": "images/trees/mushroom/stage-3.png"
      },
      {
        "name": "stage 4",
        "image": "images/trees/mushroom/stage-4.png"
      },
      {
        "name": "mature",
        "image": "images/trees/mushroom/stage-5.png"
      }
    ],
    "tapper": {
      "id": "404",
      "name": "Common Mushroom",
      "sellPrice": 40,
      "profession": ["tapper"],
      "image": "images/forageables/Common Mushroom.png",
      "energyHealth": {
        "energy": 38,
        "health": 17
      }
    },
    "choppedProduce": [
      {
        "id": "388",
        "name": "Wood"
      },
      {
        "id": "92",
        "name": "Sap"
      },
      {
        "id": "891",
        "name": "Mushroom Tree Seed"
      }
    ]
  },
  {
    "type": "wild-tree",
    "id": "13",
    "name": "Mystic Tree",
    "seedId": "MysticTreeSeed",
    "seedName": "Mystic Tree Seed",
    "description": "Not native to the valley. This otherworldly tree produces a powerful mystic syrup.",
    "image": "images/trees/mystic/portrait.png",
    "seedImage": "images/trees/mystic/seed.png",
    "stages": [
      {
        "name": "stage 1",
        "image": "images/trees/mystic/stage-1.png"
      },
      {
        "name": "stage 2",
        "image": "images/trees/mystic/stage-2.png"
      },
      {
        "name": "stage 3",
        "image": "images/trees/mystic/stage-3.png"
      },
      {
        "name": "stage 4",
        "image": "images/trees/mystic/stage-4.png"
      },
      {
        "name": "mature",
        "image": "images/trees/mystic/stage-5.png"
      }
    ],
    "tapper": {
      "id": "MysticSyrup",
      "name": "Mystic Syrup",
      "sellPrice": 1000,
      "profession": ["tapper"],
      "image": "images/forageables/Mystic Syrup.png",
      "energyHealth": {
        "energy": 500,
        "health": 225
      }
    },
    "choppedProduce": [
      {
        "id": "388",
        "name": "Wood"
      },
      {
        "id": "92",
        "name": "Sap"
      },
      {
        "id": "MysticTreeSeed",
        "name": "Mystic Tree Seed"
      }
    ]
  },
  {
    "type": "wild-tree",
    "id": "12",
    "name": "Fiddlehead Stalk",
    "seedId": "MossySeed",
    "seedName": "Mossy Seed",
    "description": "A peculiar tree that grows from Mossy Seeds. Yields Fiddlehead Ferns instead of wood when chopped. Becomes a stump during winter.",
    "image": "images/trees/fiddlehead/portrait.png",
    "seedImage": "images/trees/fiddlehead/seed.png",
    "stages": [
      {
        "name": "stage 1",
        "image": "images/trees/fiddlehead/stage-1.png"
      },
      {
        "name": "stage 2",
        "image": "images/trees/fiddlehead/stage-2.png"
      },
      {
        "name": "stage 3",
        "image": "images/trees/fiddlehead/stage-3.png"
      },
      {
        "name": "stage 4",
        "image": "images/trees/fiddlehead/stage-4.png"
      },
      {
        "name": "mature",
        "image": "images/trees/fiddlehead/stage-5.png"
      }
    ],
    "tapper": {
      "id": "259",
      "name": "Fiddlehead Fern",
      "sellPrice": 90,
      "profession": ["tiller"],
      "image": "images/forageables/Fiddlehead Fern.png",
      "energyHealth": {
        "energy": 25,
        "health": 11
      }
    },
    "choppedProduce": [
      {
        "id": "259",
        "name": "Fiddlehead Fern"
      },
      {
        "id": "MossySeed",
        "name": "Mossy Seed"
      }
    ]
  },
  {
    "type": "wild-tree",
    "id": "6",
    "name": "Palm Tree",
    "description": "A tall tree found in the Calico Desert and on Ginger Island. Cannot be cultivated by players. Shaking or chopping it may yield a Coconut.",
    "image": "images/trees/palm/portrait.png",
    "stages": [
      {
        "name": "stage 1",
        "image": "images/trees/palm/stage-1.png"
      },
      {
        "name": "stage 2",
        "image": "images/trees/palm/stage-2.png"
      },
      {
        "name": "mature",
        "image": "images/trees/palm/stage-3.png"
      }
    ],
    "choppedProduce": [
      {
        "id": "388",
        "name": "Wood"
      },
      {
        "id": "88",
        "name": "Coconut"
      },
      {
        "id": "791",
        "name": "Golden Coconut",
        "image": "images/minerals/geodes/Golden Coconut.png"
      }
    ]
  }
]
